import React from 'react'
import Header from '../../Universal/Header'
import Footer from '../../Universal/Footer'
import profileImg from "../../../theme/assets/images/intersect.svg"
const { REACT_APP_BRANDURL } = process.env;

const Profile = () => {
    return (
        <>
            <Header />
            <section className="hero-section member-banner">
                <div className="banner-image">
                    <img src={`${REACT_APP_BRANDURL}theme/assets/images/home/member-banner.jpg`} className="img-fluid" />
                </div>
                <div className="hero-content">
                    <h1 className="fw-bold">Our <span>Profile</span></h1>
                </div>
            </section>

            <section className='inner-profile'>
                <div className='container-fluid container-xxl container-lg'>
                    <div className='row justify-content-center'>
                        <atrical className="text-center mb-5 profile-profile">
                            <figure className='profile'>
                                <img src={profileImg} />
                            </figure>
                            <h3>Profile name</h3>
                            <button className='btn'>Upload image</button>
                        </atrical>
                        <div className='col-lg-4 mb-3'>
                            <div className='form-group'>
                                <label>First name: *</label>
                                <input type="text"
                                    className="form-control"
                                    placeholder="Enter first name"
                                    name="first_name" />
                            </div>
                        </div>
                        <div className='col-lg-4 mb-3'>
                            <div className='form-group'>
                                <label>Middle name:</label>
                                <input type="text"
                                    className="form-control"
                                    placeholder="Enter middle name"
                                    name="middle_name" />
                            </div>
                        </div>
                        <div className='col-lg-4 mb-3'>
                            <div className='form-group'>
                                <label>Family name / surname: *</label>
                                <input type="text"
                                    className="form-control"
                                    placeholder="Enter surname"
                                    name="last_name" />
                            </div>
                        </div>
                        <div className='col-lg-4 mb-3'>
                            <div className='form-group'>
                                <label>Discipline: <span className="text-primary">(Architecture, Civil, Electrical, Mechanical, Metallurgy, Mining, etc)</span></label>
                                <select
                                    className="form-control"
                                    name="discipline"
                                    value={''}
                                >
                                    <option value="">Select discipline</option>
                                    <option value="Architecture">Architecture</option>
                                    <option value="Civil">Civil</option>
                                    <option value="Electrical">Electrical</option>
                                    <option value="Mechanical">Mechanical</option>
                                    <option value="Metallurgy">Metallurgy</option>
                                    <option value="Mining">Mining</option>
                                </select>
                            </div>
                        </div>
                        <div className='col-lg-4 mb-3'>
                            <div className='form-group'>
                                <label>Year of Passing:</label>
                                <select
                                    className="form-control"
                                    name="passing_year"
                                    value={''}
                                >
                                    <option value="">Select year of passing</option>
                                    {Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                        <option key={year} value={year}>{year}</option>
                                    ))}
                                </select>

                            </div>
                        </div>
                        <div className='col-lg-4 mb-3'>
                            <div className='form-group'>
                                <label>Date of Birth:</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="date_of_birth"
                                    value={''}
                                />
                            </div>
                        </div>
                        <div className='col-lg-7'>
                            <div className='form-group'>
                                <label>
                                    Postal address:
                                    <span className="text-primary">(Includes flat no, floor no, house no, street, area, village,
                                        district etc)</span>
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter postal address"
                                    name="postal_address"
                                    value={''}
                                ></textarea>
                            </div>
                        </div>
                        <div className='col-lg-5'>
                            <div className='row'>
                                <div className='col-lg-12'>
                                    <div className='form-group'>
                                        <label>State:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter state"
                                            name="state"
                                            value={''}
                                        />
                                    </div>
                                </div>
                                <div className='col-lg-12'>
                                    <div className='form-group'>
                                        <label>Country:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter country"
                                            name="country"
                                            value={''}
                                        />
                                    </div>
                                </div>
                                <div className='col-lg-12'>
                                    <div className='form-group'>
                                        <label>Pin code:</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Enter pin code"
                                            name="pin_code"
                                            value={''}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='form-group'>
                                <label>Email ID: <span className="text-danger">*</span></label>
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter Email ID"
                                    name="email_id"
                                    value={''}
                                    required
                                />
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='form-group'>
                                <label>Mobile Number: <span className="text-danger">*</span></label>
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Enter mobile number"
                                    name="mobile_number"
                                    value={''}
                                    required
                                />
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='form-group'>
                                <label>Name of spouse:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter spouse name"
                                    name="spouse_name"
                                    value={''}
                                />
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='form-group'>
                                <label>Introduce by:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter introducer name"
                                    name="introduce_by"
                                    value={''}
                                />
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <label>Year of passing:</label>
                            <div className='form-group'>
                                <select
                                    className="form-control"
                                    name="introduce_passing_year"
                                    value={''}
                                >
                                    <option value="">Select year of passing</option>
                                    {Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                        <option key={year} value={year}>{year}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='form-group'>
                                <label>Discipline:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter introducer discipline"
                                    name="introduce_discipline"
                                    value={''}
                                />
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-8 col-sm-10 col-12'>
                            <button class="submit-btn">SUBMIT DETAILS</button>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Profile